import { render, staticRenderFns } from "./ClassQuadrantInterp.vue?vue&type=template&id=622d91fa&scoped=true&"
import script from "./ClassQuadrantInterp.vue?vue&type=script&lang=js&"
export * from "./ClassQuadrantInterp.vue?vue&type=script&lang=js&"
import style0 from "./ClassQuadrantInterp.vue?vue&type=style&index=0&id=622d91fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d91fa",
  null
  
)

export default component.exports